import * as React from "react";
import { SVGProps } from "react";
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m264.8 604.7 61.8 61.8L512 481.1l185.4 185.4 61.8-61.8L512 357.5z" />
  </svg>
);
export default SvgCloseIcon;
